import styled from 'styled-components'

import checkboxActive from 'images/checkboxActive.svg'
import checkbox from 'images/checkbox.svg'

export const Container = styled.div`
	flex: 1;
	align-self: stretch;
	display: flex;
	flex-direction: column;
	align-items: stretch;
`

interface OptionRowProps {
	selectionBackground: string
}

export const OptionHolder = styled.div<OptionRowProps>`
	&.upperBorder {
		border-top: 1px solid ${({ selectionBackground }) => selectionBackground};
		border-radius: 0 0 16px 16px;
	};
`

export const Option = styled.div<OptionRowProps>`
	display: flex;
	flex-direction: row;
	align-items: center;
	border-radius: 16px;
	margin: 6px 0;
	padding: 15px;
	
	&.selected {
		background: ${({ selectionBackground }) => selectionBackground};
	}
	
	transition: background 300ms ease;
`

interface OptionIconProps {
	selected: boolean
}

export const OptionIcon = styled.img.attrs((props: OptionIconProps) => ({
	src: props.selected
		? checkboxActive
		: checkbox,
}))<OptionIconProps>`
	margin-right: 16px;
`
